import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'

export const CancelCheckoutButton = ({
  onClick,
  text = 'Continue shopping',
}: {
  onClick: () => void
  text?: string
}) => {
  return <BusyButton text={text} icon="chevron-left" onClick={onClick} />
}
